import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { getTopAstrologers, getUserGrowth } from '../../services/dashboard.services';

const ReportsAnalytics = () => {
  const [growth, setGrowth] = useState([]);
  const [topAstrologers, setTopAstrologers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getUserGrowth(),
      getTopAstrologers()
    ]).then(([growthRes, topRes]) => {
      setGrowth(growthRes.data || []);
      setTopAstrologers(topRes.data || []);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <div className="container py-5 placeholder-glow"><div className="placeholder" style={{ height: '400px' }}></div></div>;
  }

  return (
    <div className="container py-5">
      <h1 className="mb-4">Reports & Analytics</h1>

      <div className="row g-4">
        <div className="col-lg-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">User Growth (Last 30 Days)</h5>
              <ResponsiveContainer width="100%" height={400}>
                <BarChart data={growth}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="newUsers" fill="#0d6efd" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-light">
              <h5 className="mb-0">Top Astrologers</h5>
            </div>
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Earnings</th>
                    <th>Sessions</th>
                  </tr>
                </thead>
                <tbody>
                  {topAstrologers.map((a, i) => (
                    <tr key={i}>
                      <td>{a.name}</td>
                      <td>₹{a.earnings?.toLocaleString() ?? 0}</td>
                      <td>{a.sessions}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsAnalytics;